import styled from 'styled-components';
import { parseTheme, size } from 'mol-ui';

export const Container = styled.div `
    align-items: center;
    border-bottom: solid 1px ${ ({ theme: { disabledColor } }) => disabledColor };
    display: flex;
    justify-content: space-between;
    padding: 10px 0px;
    ${ size.md(`
        padding: 10px 20px;
    `) }

    &:last-child {
        border-bottom: none;
    }
`;

export const Label = styled.span `
    color: ${ ({ theme: { textColor } }) => textColor };
    font-size: 17px;
    font-weight: 500;
    margin: 0;
    ${ size.md(`
        font-size: 12px;
    `) }
`;

export const Information = styled.p `
    ${ parseTheme('color', 'primaryColor') }
    font-size: 17px;
    font-weight: 500;
    margin: 0;
    ${ size.md(`
        font-size: 12px;
    `) }
`;
